// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig:
  {
    apiKey: "AIzaSyBIHAMkpuBfTgvEeOxkd5xZ-bn9oYWNvM0",
    authDomain: "steel-bonnet-apps.firebaseapp.com",
    databaseURL: "https://steel-bonnet-apps.firebaseio.com",
    projectId: "steel-bonnet-apps",
    storageBucket: "steel-bonnet-apps.appspot.com",
    messagingSenderId: "66780708885",
    appId: "1:66780708885:web:0dcf376554ccbd31614e1c",
    measurementId: "G-FQJG91FF0Y"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
